import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import '../../../styles/photosSingle.css';
import Skeleton from '../skelton'
import { Helmet } from "react-helmet-async";
import SingleRelatedSection from "./singleRelatedSection";
import { DeviceContext } from "../photosMain";
import PageAds from "../../common/pageAds";

const PhotosSingle = ({ data }) => {

  const location = useLocation();
 let url = location.pathname


  // -------- SSR DATA --------
  const ssr = data?.[0]?.singlePageData || {};
    const [photoData, setPhotoData] = useState(ssr.singleData || []);
    const [lightbox, setLightbox] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hydrate,setHydrate] = useState(true)
    const {mobile,setMobile,containerRef} = useContext(DeviceContext)
    const [error,setError] = useState(null)
   let clean = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.html'));
    let parts = clean.split('-');
    let picId = parts[parts.length - 1];
    let galleryId = parts[parts.length - 2];
    let catId = parts[parts.length - 3];
    let breadcrumbCat ={}
    switch (catId) {
        case "1":
        breadcrumbCat={name:"Actress",link:"/pages/actress-1.html"}
        break;
         case "2":
         breadcrumbCat={name:"Actors",link:"/pages/actors-2.html"}
        break;
         case "10":
         breadcrumbCat={name:"Events",link:"/pages/events-10.html"}
        break;
         case "11":
         breadcrumbCat={name:"Kingsize",link:"/pages/kingsize-11.html"}
        break;
         case "8":
         breadcrumbCat={name:"Movies",link:"/pages/movies-8.html"}
        break;
         case "12":
         breadcrumbCat={name:"Others",link:"/pages/others-12.html"}
        break;
         case "9":
        breadcrumbCat={name:"Wallpapers",link:"/pages/wallpapers-9.html"}
        break;
    
      default:
        break;
    }

    
   useEffect(() =>  {
  
        let start = setTimeout(() => { 
           setHydrate(false)     
        }, 500);
        return () => clearTimeout(start)

   },[])



  // -------- FETCH FUNCTION --------
  const fetchData = async () => {
  
  
    try {
     
      const res = await fetch(
        `https://teluguone.com/photos_api/photosSingleJson?picId=${picId}`
      );

      const json = await res.json();

      const apiData = json?.photos_folder || [];
      setPhotoData(apiData);

    } catch (err) {
      console.error("Fetch error:", err);
      setError(err.message)
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (ssr?.singleData?.length > 0 && String(ssrPicId) === picId) {
       setLoading(false)
    } else {
      setLoading(true)
      setPhotoData([])
      fetchData();
    }
  }, [location.pathname]);

  useEffect(() => {
  const handleKey = (e) => {
    if (e.key === "Escape") closeLightbox();
  };

  if (lightbox) window.addEventListener("keydown", handleKey);

  return () => window.removeEventListener("keydown", handleKey);
}, []);

  

  
  const current = photoData?.find(item => item.stimg);
  const prev = photoData?.find(item => item.prev_link);
  const next = photoData?.find(item => item.next_link);
  const folder = photoData?.find(item => item.folder_title);
  const ssrPicId = ssr.ssrPicId


  const openLightbox = () => {
    setLightbox(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightbox(false);
    document.body.style.overflow = "";
  };


  return (
    <>
      <main className="photos-single">
         <Helmet><title>{folder?.folder_title || ""}  HD Image & Download | TeluguOne Photos</title></Helmet> 

          <div className="alpha-filter">
             <div className="breadcrumb">
                   <Link to="/">Home</Link> / <Link to={breadcrumbCat.link}>{breadcrumbCat.name}</Link>
                         <span> / </span>
                   <Link to={folder?.folder_link ? folder.folder_link.substring(folder.folder_link.indexOf("/picture/")) : ''} >{folder?.folder_title || ""}</Link>
        </div>
          </div>

 
     <div className="photo-share-section">
       <p>Share :</p>
        <a href={`https://www.facebook.com/sharer.php?u=https://teluguone.com/photos${location.pathname}`} target="_blank">
                 <FaFacebook className="icon fb" />
        </a>
        <a href={`https://twitter.com/share?url=https://teluguone.com/photos${location.pathname}`} target="_blank">
              <FaSquareXTwitter className="icon x" />
        </a>
       
  </div>


      <section className="single-section">
        <h1 className="section-single-title">{folder?.folder_title || ""}</h1>

        <div className="slider-single-wrapper">
        <div className="slider-single-track" id="sliderTrack">

        {(loading || hydrate) && <div className="slider-single active">
            <Skeleton type={"slider-single-img"} />
        </div>}
 
       {current && <div className={`slider-single active ${hydrate ? 'd-none' : ''}`}>
          <img
            src={current.stimg ? current.stimg : ''}
            alt="photo"
            onClick={openLightbox}
            className="main-photo"
            loading="eager"
            fetchpriority="high"
          />

         
          {prev?.prev_link && (
            <Link to={prev.prev_link.substring(prev.prev_link.indexOf("/single"))} className="slider-single-btn prev">
              ←
            </Link>
          )}

          
          {next?.next_link && (
            <Link to={next.next_link.substring(next.next_link.indexOf('/single'))} className="slider-single-btn next">
              →
            </Link>
          )}

          
        </div>}
  
          

        </div>
      </div>
        {error && <p style={{width:"100%",textAlign:"center",fontWeight:"bold",color:"black"}}>No Json Data</p>}
        <div className="dl-bar">

          
 
          {prev?.prev_link && (
           <Link to={prev.prev_link.substring(prev.prev_link.indexOf("/single"))} className="btn-secondary-single">← Prev Photo </Link>
          )}

         {current && <a href={`https://www.teluguone.com/photos/download.php?f=${current.stimg ? current.stimg.substring(current.stimg.indexOf("/photos/")+8 ) : ''}`}  className="btn-primary-single" download>
            ⬇ Download
          </a>}

       {next?.next_link && (
          <Link to={next.next_link.substring(next.next_link.indexOf('/single'))}  className="btn-secondary-single">Next Photo →</Link>
       )}
       
        </div>
      </section>


    
      <SingleRelatedSection cat_id={catId} cat_name={breadcrumbCat?.name} galId={galleryId} page={"single"}   />

        <PageAds  mobile={mobile} containerRef={containerRef} />
      </main>
    
     <div
  className={`lightbox ${lightbox ? "open" : ""}`}
  onClick={closeLightbox}
>
  <button
    className="lightbox-close"
    onClick={(e) => {
      e.stopPropagation();
      closeLightbox();
    }}
  >
    ✕
  </button>

  {current && (
    <img
      className="lightbox-img"
      src={current.stimg}
      alt=""
      onClick={(e) => e.stopPropagation()}
    />
  )}
</div>
    
    </>
  );
};

export default PhotosSingle;